import { render, staticRenderFns } from "./NewDocumentEditView.vue?vue&type=template&id=c9e1fb78&scoped=true&"
import script from "./NewDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentEditView.vue?vue&type=style&index=0&id=c9e1fb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e1fb78",
  null
  
)

export default component.exports